
import { createSlice } from '@reduxjs/toolkit';
import { getLocal } from '@utils/storage';

const saved = getLocal('chart-layout') ?? {};

const chartSlice = createSlice({
    name: 'chart',
    initialState: {
        layout: { chart: saved.chart ?? 1, screen: saved.screen ?? 'A' },
        mts: getLocal('chart-mts') ?? false,
        isDark: getLocal('app-theme') === 'dark',
    },
    reducers: {
        setLayout: (state, { payload }) => { state.layout = payload; },
        setMts: (state, { payload }) => { state.mts = payload; },
        setIsDark: (state, { payload }) => { state.isDark = payload; },
        toggleMts: (state) => { state.mts = !state.mts; },
    },
});

export const { setLayout, setMts, setIsDark, toggleMts } = chartSlice.actions;
export default chartSlice.reducer;